import api from './api';

/**
 * 雷达概览数据
 */
export interface RadarOverview {
    globalLongRatio: number;
    globalShortRatio: number;
    marketSentiment: 'BULLISH' | 'BEARISH' | 'NEUTRAL';
    longDominantCount: number;
    shortDominantCount: number;
    neutralCount: number;
    totalCoinCount: number;
    topLongCoins: TopCoin[];
    topShortCoins: TopCoin[];
    radarDatasets: RadarChartDataset[];
    lastUpdateTime: string;
    timeframe: string;
}

/**
 * 顶级币种数据
 */
export interface TopCoin {
    symbol: string;
    ratio: number;
    change24h: number;
    price: number;
}

/**
 * 雷达图数据集
 */
export interface RadarChartDataset {
    label: string;
    data: number[];
    borderColor: string;
    backgroundColor: string;
}

/**
 * 雷达币种数据
 */
export interface RadarCoinData {
    symbol: string;
    instId: string;
    price: number;
    change24h: number;
    longRatio: number;
    shortRatio: number;
    longShortRatio: number;
    signal: 'STRONG_LONG' | 'LONG' | 'NEUTRAL' | 'SHORT' | 'STRONG_SHORT';
    strength: number;
    fundingRate?: number;
    openInterest?: number;
    volume24h?: number;
    dimensions?: RadarDimensions;
}

/**
 * 雷达维度数据
 */
export interface RadarDimensions {
    priceMomentum: number;
    tradingActivity: number;
    fundingTendency: number;
    longPositionRatio: number;
    socialSentiment: number;
    technicalIndicator: number;
}

/**
 * 获取雷达概览数据
 */
export const getRadarOverview = async (exchange: string = 'OKX', timeframe: string = '1H'): Promise<RadarOverview> => {
    const response = await api.get<{ data: RadarOverview }>('/api/v1/radar/overview', {
        params: {exchange, timeframe}
    });
    return response.data.data;
};

/**
 * 获取币种列表数据
 */
export const getRadarCoins = async (exchange: string = 'OKX', timeframe: string = '1H', limit: number = 20): Promise<RadarCoinData[]> => {
    const response = await api.get<{ data: RadarCoinData[] }>('/api/v1/radar/coins', {
        params: {exchange, timeframe, limit}
    });
    return response.data.data;
};

/**
 * 刷新雷达数据
 */
export const refreshRadarData = async (exchange: string = 'OKX', timeframe: string = '1H'): Promise<RadarOverview> => {
    const response = await api.post<{ data: RadarOverview }>('/api/v1/radar/refresh', null, {
        params: {exchange, timeframe}
    });
    return response.data.data;
};
